import classNames from 'classnames';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconApplePay } from '#src/atoms/icons/system/iconApplePay.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';

const Root = styled(Horizontal)`
  color: var(--c-white);
  &.column {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: var(--half-unit);
    text-align: left;
    color: var(--c-nl-100-opaque);
  }
`;

const IconContainer = styled.div`
  width: 40px;
  background-color: var(--c-black);
  padding: var(--half-unit) var(--unit);
  border-radius: var(--half-unit);
  color: var(--c-nl-1000-opaque);
`;

export const ApplePayOptionLabel = ({
  column = false,
}: {
  column?: boolean;
}) => {
  return (
    <Root className={classNames({ column })} center>
      <IconContainer>
        <FontAwesomeIcon size="lg" icon={iconApplePay} />
      </IconContainer>
      <BodyM>Apple Pay</BodyM>
    </Root>
  );
};
